import React, { useState, useEffect } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Chip,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Switch,
  FormControlLabel,
  Avatar,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Checkbox,
  Menu,
  ListItemIcon,
  ListItemText,
  Divider,
  LinearProgress,
  Fab,
  Badge
} from '@mui/material';
import {
  Add,
  Edit,
  Delete,
  Save,
  Cancel,
  Star,
  Diamond,
  EmojiEvents,
  Whatshot,
  Psychology,
  TrendingUp,
  Verified,
  WorkspacePremium,
  Shield,
  Favorite,
  LocalFireDepartment,
  Bolt,
  AutoAwesome,
  Celebration,
  Rocket,
  FlashOn,
  Loyalty,
  Security,
  MilitaryTech,
  CardGiftcard,
  Stars,
  Grade,
  NewReleases,
  Recommend,
  ThumbUp,
  Explore,
  Insights,
  Speed,
  Timeline,
  Palette,
  AdminPanelSettings,
  Work,
  LocalPolice,
  Casino,
  Pets,
  SportsEsports,
  MusicNote,
  Camera,
  Brush,
  Code,
  School,
  Business,
  Public,
  Language,
  Nature,
  FitnessCenter,
  Restaurant,
  Flight,
  DirectionsCar,
  ExpandMore,
  Sort,
  Visibility,
  VisibilityOff,
  Refresh,
  CheckBox,
  CheckBoxOutlineBlank,
  Movie,
  Theaters,
  VideoLibrary,
  LocalMovies,
  Slideshow,
  PlayCircle,
  MovieCreation,
  Videocam,
  CameraRoll,
  LiveTv,
  OndemandVideo,
  VideoCall,
  Mic,
  RecordVoiceOver,
  GraphicEq,
  AudioFile,
  Album,
  QueueMusic,
  LibraryMusic,
  MusicVideo,
  Radio,
  Headphones,
  Speaker,
  VolumeUp,
  Equalizer,
  Piano,
  Festival,
  TheaterComedy,
  Masks,
  LocalActivity,
  Event,
  Celebration as CelebrationIcon,
  Cake,
  PartyMode,
  Nightlife,
  LocalBar,
  Diversity1,
  Diversity2,
  Diversity3,
  Groups,
  People,
  Person,
  Face,
  SentimentSatisfied,
  SentimentVeryDissatisfied,
  SentimentVerySatisfied,
  Mood,
  MoodBad,
  EmojiEmotions,
  TagFaces,
  SportsKabaddi,
  FitnessCenter as Gym,
  SelfImprovement,
  DirectionsRun,
  DirectionsWalk,
  Pool,
  SportsVolleyball,
  SportsCricket,
  SportsFootball,
  SportsBaseball,
  SportsTennis,
  SportsBasketball,
  SportsHandball,
  SportsRugby,
  SportsGolf,
  SportsSoccer,
  SportsEsports as Gaming,
  SportsMotorsports,
  DirectionsBike,
  Agriculture,
  Eco,
  Forest,
  Park,
  Terrain,
  Landscape,
  WbSunny,
  NightsStay,
  Cloud,
  Thunderstorm,
  AcUnit,
  Opacity,
  Waves,
  BeachAccess,
  Sailing,
  FlightTakeoff,
  Train,
  DirectionsBus,
  LocalTaxi,
  LocalShipping,
  RocketLaunch,
  Satellite,
  Public as Globe,
  LocationCity,
  LocationOn,
  Home,
  Apartment,
  Villa,
  Foundation,
  Roofing,
  Construction,
  Architecture,
  Build,
  Handyman,
  ElectricalServices,
  FormatPaint,
  Brush as PaintBrush,
  ColorLens,
  Palette as ArtPalette,
  Draw,
  Edit as EditIcon,
  Create,
  AutoFixHigh,
  AutoFixNormal,
  AutoFixOff,
  Tune,
  Settings,
  SettingsApplications,
  DeveloperMode,
  BugReport,
  Memory,
  Storage,
  CloudQueue,
  CloudDownload,
  CloudUpload,
  Backup,
  Update,
  SystemUpdate,
  GetApp,
  Publish,
  Share,
  Send,
  Email,
  MailOutline,
  Message,
  Chat,
  ChatBubble,
  Forum,
  QuestionAnswer,
  ContactSupport,
  Help,
  Info,
  Announcement,
  Campaign,
  VolumeDown,
  VolumeOff,
  VolumeMute
} from '@mui/icons-material';
import { adminAchievementService } from '../../../services/adminAchievementService';

const BADGE_TYPES = [
  'STATUS', 'ACHIEVEMENT', 'SPECIAL_EVENT', 'SEASONAL', 'CUSTOM'
];

const BADGE_ICONS = [
  // Achievement Icons
  { name: 'Star', component: Star, category: 'Achievement' },
  { name: 'EmojiEvents', component: EmojiEvents, category: 'Achievement' },
  { name: 'Grade', component: Grade, category: 'Achievement' },
  { name: 'Stars', component: Stars, category: 'Achievement' },
  { name: 'MilitaryTech', component: MilitaryTech, category: 'Achievement' },
  { name: 'WorkspacePremium', component: WorkspacePremium, category: 'Achievement' },
  
  // Status Icons
  { name: 'Diamond', component: Diamond, category: 'Status' },
  { name: 'AdminPanelSettings', component: AdminPanelSettings, category: 'Status' },
  { name: 'Shield', component: Shield, category: 'Status' },
  { name: 'Verified', component: Verified, category: 'Status' },
  { name: 'Security', component: Security, category: 'Status' },
  { name: 'LocalPolice', component: LocalPolice, category: 'Status' },
  
  // Activity Icons
  { name: 'Whatshot', component: Whatshot, category: 'Activity' },
  { name: 'LocalFireDepartment', component: LocalFireDepartment, category: 'Activity' },
  { name: 'TrendingUp', component: TrendingUp, category: 'Activity' },
  { name: 'Bolt', component: Bolt, category: 'Activity' },
  { name: 'FlashOn', component: FlashOn, category: 'Activity' },
  { name: 'Speed', component: Speed, category: 'Activity' },
  
  // Social Icons
  { name: 'Favorite', component: Favorite, category: 'Social' },
  { name: 'ThumbUp', component: ThumbUp, category: 'Social' },
  { name: 'Recommend', component: Recommend, category: 'Social' },
  { name: 'Psychology', component: Psychology, category: 'Social' },
  { name: 'Loyalty', component: Loyalty, category: 'Social' },
  
  // Special Icons
  { name: 'AutoAwesome', component: AutoAwesome, category: 'Special' },
  { name: 'Celebration', component: Celebration, category: 'Special' },
  { name: 'Rocket', component: Rocket, category: 'Special' },
  { name: 'NewReleases', component: NewReleases, category: 'Special' },
  { name: 'CardGiftcard', component: CardGiftcard, category: 'Special' },
  { name: 'Explore', component: Explore, category: 'Special' },
  { name: 'Insights', component: Insights, category: 'Special' },
  { name: 'Timeline', component: Timeline, category: 'Special' },
  { name: 'Palette', component: Palette, category: 'Special' },
  { name: 'Work', component: Work, category: 'Special' },
  
  // Telugu Cinema & Movies
  { name: 'Movie', component: Movie, category: 'Telugu Cinema' },
  { name: 'Theaters', component: Theaters, category: 'Telugu Cinema' },
  { name: 'VideoLibrary', component: VideoLibrary, category: 'Telugu Cinema' },
  { name: 'LocalMovies', component: LocalMovies, category: 'Telugu Cinema' },
  { name: 'Slideshow', component: Slideshow, category: 'Telugu Cinema' },
  { name: 'PlayCircle', component: PlayCircle, category: 'Telugu Cinema' },
  { name: 'MovieCreation', component: MovieCreation, category: 'Telugu Cinema' },
  { name: 'Videocam', component: Videocam, category: 'Telugu Cinema' },
  { name: 'CameraRoll', component: CameraRoll, category: 'Telugu Cinema' },
  { name: 'LiveTv', component: LiveTv, category: 'Telugu Cinema' },
  { name: 'OndemandVideo', component: OndemandVideo, category: 'Telugu Cinema' },
  { name: 'TheaterComedy', component: TheaterComedy, category: 'Telugu Cinema' },
  { name: 'Masks', component: Masks, category: 'Telugu Cinema' },
  
  // Music & Audio
  { name: 'Mic', component: Mic, category: 'Music' },
  { name: 'RecordVoiceOver', component: RecordVoiceOver, category: 'Music' },
  { name: 'Album', component: Album, category: 'Music' },
  { name: 'QueueMusic', component: QueueMusic, category: 'Music' },
  { name: 'LibraryMusic', component: LibraryMusic, category: 'Music' },
  { name: 'MusicVideo', component: MusicVideo, category: 'Music' },
  { name: 'Radio', component: Radio, category: 'Music' },
  { name: 'Headphones', component: Headphones, category: 'Music' },
  { name: 'VolumeUp', component: VolumeUp, category: 'Music' },
  
  // Sports & Action
  { name: 'SportsKabaddi', component: SportsKabaddi, category: 'Sports' },
  { name: 'SportsCricket', component: SportsCricket, category: 'Sports' },
  { name: 'SportsFootball', component: SportsFootball, category: 'Sports' },
  { name: 'SportsBasketball', component: SportsBasketball, category: 'Sports' },
  { name: 'SportsMotorsports', component: SportsMotorsports, category: 'Sports' },
  { name: 'DirectionsBike', component: DirectionsBike, category: 'Sports' },
  { name: 'DirectionsRun', component: DirectionsRun, category: 'Sports' },
  
  // Culture & Tradition
  { name: 'LocalActivity', component: LocalActivity, category: 'Culture' },
  { name: 'Agriculture', component: Agriculture, category: 'Culture' },
  { name: 'WbSunny', component: WbSunny, category: 'Culture' },
  { name: 'NightsStay', component: NightsStay, category: 'Culture' },
  { name: 'Waves', component: Waves, category: 'Culture' },
  { name: 'LocationCity', component: LocationCity, category: 'Culture' },
  { name: 'Home', component: Home, category: 'Culture' },
  
  // Emotions
  { name: 'Face', component: Face, category: 'Emotions' },
  { name: 'SentimentSatisfied', component: SentimentSatisfied, category: 'Emotions' },
  { name: 'SentimentVerySatisfied', component: SentimentVerySatisfied, category: 'Emotions' },
  { name: 'Mood', component: Mood, category: 'Emotions' },
  { name: 'EmojiEmotions', component: EmojiEmotions, category: 'Emotions' },
  
  // Hobby & Interest Icons
  { name: 'Casino', component: Casino, category: 'Hobby' },
  { name: 'Pets', component: Pets, category: 'Hobby' },
  { name: 'SportsEsports', component: SportsEsports, category: 'Hobby' },
  { name: 'MusicNote', component: MusicNote, category: 'Hobby' },
  { name: 'Camera', component: Camera, category: 'Hobby' },
  { name: 'Brush', component: Brush, category: 'Hobby' },
  { name: 'Code', component: Code, category: 'Hobby' },
  { name: 'School', component: School, category: 'Hobby' },
  { name: 'Business', component: Business, category: 'Hobby' },
  { name: 'Public', component: Public, category: 'Hobby' },
  { name: 'Language', component: Language, category: 'Hobby' },
  { name: 'Nature', component: Nature, category: 'Hobby' },
  { name: 'FitnessCenter', component: FitnessCenter, category: 'Hobby' },
  { name: 'Restaurant', component: Restaurant, category: 'Hobby' },
  { name: 'Flight', component: Flight, category: 'Hobby' },
  { name: 'DirectionsCar', component: DirectionsCar, category: 'Hobby' },
  { name: 'Train', component: Train, category: 'Hobby' }
];

const COLOR_PRESETS = [
  // Gold & Yellow
  { name: 'Gold', value: '#FFD700', category: 'Premium' },
  { name: 'Amber', value: '#FFC107', category: 'Premium' },
  { name: 'Yellow', value: '#FFEB3B', category: 'Premium' },
  
  // Blue Variants
  { name: 'Blue', value: '#2196F3', category: 'Standard' },
  { name: 'Light Blue', value: '#03A9F4', category: 'Standard' },
  { name: 'Cyan', value: '#00BCD4', category: 'Standard' },
  { name: 'Indigo', value: '#3F51B5', category: 'Standard' },
  
  // Purple & Pink
  { name: 'Purple', value: '#9C27B0', category: 'Premium' },
  { name: 'Deep Purple', value: '#673AB7', category: 'Premium' },
  { name: 'Pink', value: '#E91E63', category: 'Premium' },
  
  // Red & Orange
  { name: 'Red', value: '#F44336', category: 'Alert' },
  { name: 'Orange', value: '#FF9800', category: 'Alert' },
  { name: 'Deep Orange', value: '#FF5722', category: 'Alert' },
  
  // Green Variants
  { name: 'Green', value: '#4CAF50', category: 'Success' },
  { name: 'Light Green', value: '#8BC34A', category: 'Success' },
  { name: 'Teal', value: '#009688', category: 'Success' },
  
  // Neutral Colors
  { name: 'Grey', value: '#9E9E9E', category: 'Neutral' },
  { name: 'Blue Grey', value: '#607D8B', category: 'Neutral' },
  { name: 'Brown', value: '#795548', category: 'Neutral' },
  
  // Special Colors
  { name: 'Black', value: '#212121', category: 'Special' },
  { name: 'White', value: '#FAFAFA', category: 'Special' },
  { name: 'Silver', value: '#C0C0C0', category: 'Special' },
  { name: 'Bronze', value: '#CD7F32', category: 'Special' },
  
  // Gradient Colors
  { name: 'Sunset', value: '#FF6B35', category: 'Gradient' },
  { name: 'Ocean', value: '#006A6B', category: 'Gradient' },
  { name: 'Forest', value: '#228B22', category: 'Gradient' },
  { name: 'Lavender', value: '#9370DB', category: 'Gradient' },
  { name: 'Rose Gold', value: '#E8B4B8', category: 'Gradient' },
  { name: 'Mint', value: '#98FB98', category: 'Gradient' }
];

const BADGE_CONDITION_TYPES = [
  { value: 'FOLLOWER_COUNT', label: 'Follower Count' },
  { value: 'POSTS_CREATED', label: 'Posts Created' },
  { value: 'REVIEWS_WRITTEN', label: 'Reviews Written' },
  { value: 'MOVIES_WATCHED', label: 'Movies Watched' },
  { value: 'LOGIN_STREAK', label: 'Login Streak' },
  { value: 'EARLY_DISCOVERIES', label: 'Early Discoveries' },
  { value: 'SPECIFIC_MOVIE_WATCHED', label: 'Specific Movie Watched' },
  { value: 'GENRE_WATCHED_COUNT', label: 'Genre Watched Count' },
  { value: 'SEASONAL_ACTIVITY', label: 'Seasonal Activity' }
];

const EnhancedBadgeManager = () => {
  const [badges, setBadges] = useState([]);
  const [filteredBadges, setFilteredBadges] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editingBadge, setEditingBadge] = useState(null);
  const [selectedBadges, setSelectedBadges] = useState([]);
  const [sortBy, setSortBy] = useState('name');
  const [sortOrder, setSortOrder] = useState('asc');
  const [filterType, setFilterType] = useState('ALL');
  const [filterStatus, setFilterStatus] = useState('ALL');
  const [searchQuery, setSearchQuery] = useState('');
  const [bulkMenuAnchor, setBulkMenuAnchor] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedIconCategory, setSelectedIconCategory] = useState('All');
  const [selectedColorCategory, setSelectedColorCategory] = useState('All');
  
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    type: 'STATUS',
    icon: 'Star',
    color: '#FFD700',
    isActive: true,
    autoAssign: false,
    conditionType: 'FOLLOWER_COUNT',
    threshold: 1,
    movieIds: '',
    genre: '',
    month: 1
  });

  useEffect(() => {
    loadBadges();
  }, []);

  useEffect(() => {
    filterAndSortBadges();
  }, [badges, searchQuery, filterType, filterStatus, sortBy, sortOrder]);

  const loadBadges = async () => {
    setLoading(true);
    try {
      const data = await adminAchievementService.getAllBadges();
      setBadges(data);
    } catch (error) {
      console.error('Error loading badges:', error);
    } finally {
      setLoading(false);
    }
  };

  const filterAndSortBadges = () => {
    let filtered = [...badges];

    if (searchQuery) {
      filtered = filtered.filter(badge => 
        badge.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        badge.description.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    if (filterType !== 'ALL') {
      filtered = filtered.filter(badge => badge.type === filterType);
    }

    if (filterStatus !== 'ALL') {
      const isActive = filterStatus === 'ACTIVE';
      filtered = filtered.filter(badge => badge.isActive === isActive);
    }

    filtered.sort((a, b) => {
      let aValue = a[sortBy];
      let bValue = b[sortBy];
      
      if (typeof aValue === 'string') {
        aValue = aValue.toLowerCase();
        bValue = bValue.toLowerCase();
      }
      
      if (sortOrder === 'asc') {
        return aValue > bValue ? 1 : -1;
      } else {
        return aValue < bValue ? 1 : -1;
      }
    });

    setFilteredBadges(filtered);
  };

  const groupedBadges = () => {
    const groups = {};
    filteredBadges.forEach(badge => {
      const type = badge.type || 'UNCATEGORIZED';
      if (!groups[type]) {
        groups[type] = [];
      }
      groups[type].push(badge);
    });
    return groups;
  };

  const handleBulkAction = async (action) => {
    if (selectedBadges.length === 0) return;
    
    setLoading(true);
    try {
      switch (action) {
        case 'activate':
          await Promise.all(selectedBadges.map(id => 
            adminAchievementService.updateBadge(id, { isActive: true })
          ));
          break;
        case 'deactivate':
          await Promise.all(selectedBadges.map(id => 
            adminAchievementService.updateBadge(id, { isActive: false })
          ));
          break;
        case 'delete':
          if (window.confirm(`Delete ${selectedBadges.length} badges?`)) {
            await Promise.all(selectedBadges.map(id => 
              adminAchievementService.deleteBadge(id)
            ));
          }
          break;
      }
      setSelectedBadges([]);
      await loadBadges();
    } catch (error) {
      console.error('Bulk action error:', error);
    } finally {
      setLoading(false);
      setBulkMenuAnchor(null);
    }
  };

  const handleSelectBadge = (id) => {
    setSelectedBadges(prev => 
      prev.includes(id) 
        ? prev.filter(selectedId => selectedId !== id)
        : [...prev, id]
    );
  };

  const handleSave = async () => {
    try {
      const conditions = {
        type: formData.conditionType,
        threshold: formData.threshold
      };

      switch (formData.conditionType) {
        case 'SPECIFIC_MOVIE_WATCHED':
          conditions.movieIds = formData.movieIds.split(',').map(id => id.trim()).filter(Boolean);
          break;
        case 'GENRE_WATCHED_COUNT':
          conditions.genre = formData.genre;
          break;
        case 'SEASONAL_ACTIVITY':
          conditions.month = formData.month;
          conditions.genre = formData.genre;
          break;
      }

      const saveData = {
        ...formData,
        conditions: JSON.stringify(conditions)
      };

      if (editingBadge) {
        await adminAchievementService.updateBadge(editingBadge.id, saveData);
      } else {
        await adminAchievementService.createBadge(saveData);
      }
      await loadBadges();
      handleCloseDialog();
    } catch (error) {
      console.error('Error saving badge:', error);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this badge?')) {
      try {
        await adminAchievementService.deleteBadge(id);
        await loadBadges();
      } catch (error) {
        console.error('Error deleting badge:', error);
      }
    }
  };

  const handleEdit = (badge) => {
    setEditingBadge(badge);
    let parsedConditions = {};
    if (badge.conditions) {
      try {
        parsedConditions = JSON.parse(badge.conditions);
      } catch (e) {
        console.warn('Could not parse badge conditions:', e);
      }
    }
    
    setFormData({
      ...badge,
      conditionType: parsedConditions.type || 'FOLLOWER_COUNT',
      threshold: parsedConditions.threshold || 1,
      movieIds: (parsedConditions.movieIds || []).join(','),
      genre: parsedConditions.genre || '',
      month: parsedConditions.month || 1
    });
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setEditingBadge(null);
    setFormData({
      name: '',
      description: '',
      type: 'STATUS',
      icon: 'Star',
      color: '#FFD700',
      isActive: true,
      autoAssign: false,
      conditionType: 'FOLLOWER_COUNT',
      threshold: 1,
      movieIds: '',
      genre: '',
      month: 1
    });
    setSelectedIconCategory('All');
    setSelectedColorCategory('All');
  };

  const getFilteredIcons = () => {
    if (selectedIconCategory === 'All') return BADGE_ICONS;
    return BADGE_ICONS.filter(icon => icon.category === selectedIconCategory);
  };

  const getFilteredColors = () => {
    if (selectedColorCategory === 'All') return COLOR_PRESETS;
    return COLOR_PRESETS.filter(color => color.category === selectedColorCategory);
  };

  const getIconCategories = () => {
    const categories = [...new Set(BADGE_ICONS.map(icon => icon.category))];
    return ['All', ...categories];
  };

  const getColorCategories = () => {
    const categories = [...new Set(COLOR_PRESETS.map(color => color.category))];
    return ['All', ...categories];
  };

  const getIconComponent = (iconName) => {
    const iconData = BADGE_ICONS.find(icon => icon.name === iconName);
    return iconData ? iconData.component : Star;
  };

  const typeGroups = groupedBadges();

  return (
    <Box>
      {loading && <LinearProgress sx={{ mb: 2 }} />}
      
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h4">Badge Management</Typography>
        <Box display="flex" gap={2}>
          <Button
            variant="outlined"
            startIcon={<Refresh />}
            onClick={loadBadges}
            disabled={loading}
          >
            Refresh
          </Button>
          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={() => setDialogOpen(true)}
          >
            Create Badge
          </Button>
        </Box>
      </Box>

      {/* Filters */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                size="small"
                label="Search"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </Grid>
            <Grid item xs={6} md={2}>
              <FormControl fullWidth size="small">
                <InputLabel>Type</InputLabel>
                <Select
                  value={filterType}
                  onChange={(e) => setFilterType(e.target.value)}
                >
                  <MenuItem value="ALL">All Types</MenuItem>
                  {BADGE_TYPES.map(type => (
                    <MenuItem key={type} value={type}>{type}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6} md={2}>
              <FormControl fullWidth size="small">
                <InputLabel>Status</InputLabel>
                <Select
                  value={filterStatus}
                  onChange={(e) => setFilterStatus(e.target.value)}
                >
                  <MenuItem value="ALL">All Status</MenuItem>
                  <MenuItem value="ACTIVE">Active</MenuItem>
                  <MenuItem value="INACTIVE">Inactive</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6} md={2}>
              <FormControl fullWidth size="small">
                <InputLabel>Sort By</InputLabel>
                <Select
                  value={sortBy}
                  onChange={(e) => setSortBy(e.target.value)}
                >
                  <MenuItem value="name">Name</MenuItem>
                  <MenuItem value="type">Type</MenuItem>
                  <MenuItem value="createdAt">Created</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6} md={2}>
              <IconButton
                onClick={() => setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')}
                title={`Sort ${sortOrder === 'asc' ? 'Descending' : 'Ascending'}`}
              >
                <Sort sx={{ transform: sortOrder === 'desc' ? 'rotate(180deg)' : 'none' }} />
              </IconButton>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Bulk Actions */}
      {selectedBadges.length > 0 && (
        <Card sx={{ mb: 2, bgcolor: 'primary.light', color: 'primary.contrastText' }}>
          <CardContent sx={{ py: 1 }}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography variant="subtitle2">
                {selectedBadges.length} badge(s) selected
              </Typography>
              <Box>
                <Button
                  size="small"
                  onClick={() => setBulkMenuAnchor(document.getElementById('bulk-menu-button'))}
                  id="bulk-menu-button"
                  sx={{ color: 'inherit' }}
                >
                  Bulk Actions
                </Button>
                <Menu
                  anchorEl={bulkMenuAnchor}
                  open={Boolean(bulkMenuAnchor)}
                  onClose={() => setBulkMenuAnchor(null)}
                >
                  <MenuItem onClick={() => handleBulkAction('activate')}>
                    <ListItemIcon><Visibility /></ListItemIcon>
                    <ListItemText>Activate</ListItemText>
                  </MenuItem>
                  <MenuItem onClick={() => handleBulkAction('deactivate')}>
                    <ListItemIcon><VisibilityOff /></ListItemIcon>
                    <ListItemText>Deactivate</ListItemText>
                  </MenuItem>
                  <Divider />
                  <MenuItem onClick={() => handleBulkAction('delete')} sx={{ color: 'error.main' }}>
                    <ListItemIcon><Delete color="error" /></ListItemIcon>
                    <ListItemText>Delete</ListItemText>
                  </MenuItem>
                </Menu>
                <Button
                  size="small"
                  onClick={() => setSelectedBadges([])}
                  sx={{ color: 'inherit', ml: 1 }}
                >
                  Clear
                </Button>
              </Box>
            </Box>
          </CardContent>
        </Card>
      )}

      {/* Grouped View */}
      <Box>
        {Object.entries(typeGroups).map(([type, typeBadges]) => (
          <Accordion key={type} defaultExpanded>
            <AccordionSummary expandIcon={<ExpandMore />}>
              <Box display="flex" alignItems="center" gap={2}>
                <Typography variant="h6">{type}</Typography>
                <Badge badgeContent={typeBadges.length} color="primary" />
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell padding="checkbox">
                        <Checkbox
                          indeterminate={selectedBadges.length > 0 && selectedBadges.length < typeBadges.length}
                          checked={typeBadges.length > 0 && typeBadges.every(b => selectedBadges.includes(b.id))}
                          onChange={() => {
                            const typeIds = typeBadges.map(b => b.id);
                            const allSelected = typeIds.every(id => selectedBadges.includes(id));
                            if (allSelected) {
                              setSelectedBadges(prev => prev.filter(id => !typeIds.includes(id)));
                            } else {
                              setSelectedBadges(prev => [...new Set([...prev, ...typeIds])]);
                            }
                          }}
                        />
                      </TableCell>
                      <TableCell>Badge</TableCell>
                      <TableCell>Condition</TableCell>
                      <TableCell>Auto Assign</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {typeBadges.map((badge) => (
                      <TableRow key={badge.id} selected={selectedBadges.includes(badge.id)}>
                        <TableCell padding="checkbox">
                          <Checkbox
                            checked={selectedBadges.includes(badge.id)}
                            onChange={() => handleSelectBadge(badge.id)}
                          />
                        </TableCell>
                        <TableCell>
                          <Box display="flex" alignItems="center" gap={1}>
                            <Avatar sx={{ bgcolor: badge.color, width: 32, height: 32 }}>
                              {React.createElement(getIconComponent(badge.icon), { sx: { fontSize: 18 } })}
                            </Avatar>
                            <Box>
                              <Typography variant="subtitle2">{badge.name}</Typography>
                              <Typography variant="caption" color="text.secondary">
                                {badge.description}
                              </Typography>
                            </Box>
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Chip 
                            label={badge.conditionType || 'Manual'} 
                            size="small" 
                            variant="outlined"
                          />
                        </TableCell>
                        <TableCell>
                          <Chip
                            label={badge.autoAssign ? 'Yes' : 'No'}
                            color={badge.autoAssign ? 'success' : 'default'}
                            size="small"
                          />
                        </TableCell>
                        <TableCell>
                          <Chip
                            label={badge.isActive ? 'Active' : 'Inactive'}
                            color={badge.isActive ? 'success' : 'default'}
                            size="small"
                          />
                        </TableCell>
                        <TableCell>
                          <IconButton onClick={() => handleEdit(badge)} size="small">
                            <Edit />
                          </IconButton>
                          <IconButton onClick={() => handleDelete(badge.id)} size="small">
                            <Delete />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>

      <Fab
        color="primary"
        sx={{ position: 'fixed', bottom: 16, right: 16 }}
        onClick={() => setDialogOpen(true)}
      >
        <Add />
      </Fab>

      {/* Dialog */}
      <Dialog open={dialogOpen} onClose={handleCloseDialog} maxWidth="md" fullWidth>
        <DialogTitle>
          {editingBadge ? 'Edit Badge' : 'Create Badge'}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Name"
                value={formData.name}
                onChange={(e) => setFormData(prev => ({ ...prev, name: e.target.value }))}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Type</InputLabel>
                <Select
                  value={formData.type}
                  onChange={(e) => setFormData(prev => ({ ...prev, type: e.target.value }))}
                >
                  {BADGE_TYPES.map(type => (
                    <MenuItem key={type} value={type}>{type}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Description"
                multiline
                rows={2}
                value={formData.description}
                onChange={(e) => setFormData(prev => ({ ...prev, description: e.target.value }))}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle2" gutterBottom>Icon Selection</Typography>
              <Box sx={{ mb: 2 }}>
                <FormControl size="small" sx={{ minWidth: 120, mr: 1 }}>
                  <InputLabel>Category</InputLabel>
                  <Select
                    value={selectedIconCategory}
                    onChange={(e) => setSelectedIconCategory(e.target.value)}
                  >
                    {getIconCategories().map(category => (
                      <MenuItem key={category} value={category}>{category}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
              <Box sx={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(auto-fill, minmax(80px, 1fr))', 
                gap: 1, 
                maxHeight: 200, 
                overflowY: 'auto',
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 1,
                p: 1
              }}>
                {getFilteredIcons().map(icon => {
                  const IconComponent = icon.component;
                  const isSelected = formData.icon === icon.name;
                  return (
                    <Box
                      key={icon.name}
                      onClick={() => setFormData(prev => ({ ...prev, icon: icon.name }))}
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        p: 1,
                        cursor: 'pointer',
                        borderRadius: 1,
                        border: '2px solid',
                        borderColor: isSelected ? 'primary.main' : 'transparent',
                        bgcolor: isSelected ? 'primary.50' : 'transparent',
                        '&:hover': {
                          bgcolor: 'action.hover'
                        }
                      }}
                    >
                      <IconComponent sx={{ fontSize: 24, mb: 0.5 }} />
                      <Typography variant="caption" textAlign="center" sx={{ fontSize: '0.6rem' }}>
                        {icon.name}
                      </Typography>
                    </Box>
                  );
                })}
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle2" gutterBottom>Color Selection</Typography>
              <Box sx={{ mb: 2 }}>
                <FormControl size="small" sx={{ minWidth: 120, mr: 1 }}>
                  <InputLabel>Category</InputLabel>
                  <Select
                    value={selectedColorCategory}
                    onChange={(e) => setSelectedColorCategory(e.target.value)}
                  >
                    {getColorCategories().map(category => (
                      <MenuItem key={category} value={category}>{category}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <TextField
                  size="small"
                  label="Custom Color"
                  type="color"
                  value={formData.color}
                  onChange={(e) => setFormData(prev => ({ ...prev, color: e.target.value }))}
                  sx={{ ml: 1, width: 100 }}
                />
              </Box>
              <Box sx={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(auto-fill, minmax(60px, 1fr))', 
                gap: 1, 
                maxHeight: 150, 
                overflowY: 'auto',
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 1,
                p: 1
              }}>
                {getFilteredColors().map(colorPreset => {
                  const isSelected = formData.color === colorPreset.value;
                  return (
                    <Box
                      key={colorPreset.name}
                      onClick={() => setFormData(prev => ({ ...prev, color: colorPreset.value }))}
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        p: 1,
                        cursor: 'pointer',
                        borderRadius: 1,
                        border: '2px solid',
                        borderColor: isSelected ? 'primary.main' : 'transparent',
                        '&:hover': {
                          bgcolor: 'action.hover'
                        }
                      }}
                    >
                      <Box
                        sx={{
                          width: 32,
                          height: 32,
                          bgcolor: colorPreset.value,
                          borderRadius: '50%',
                          mb: 0.5,
                          border: '1px solid',
                          borderColor: 'divider'
                        }}
                      />
                      <Typography variant="caption" textAlign="center" sx={{ fontSize: '0.6rem' }}>
                        {colorPreset.name}
                      </Typography>
                    </Box>
                  );
                })}
              </Box>
            </Grid>
            {/* Badge Preview */}
            <Grid item xs={12}>
              <Typography variant="subtitle2" gutterBottom>Badge Preview</Typography>
              <Card sx={{ p: 2, bgcolor: 'background.paper', border: '1px solid', borderColor: 'divider' }}>
                <Box display="flex" alignItems="center" gap={2}>
                  <Avatar sx={{ bgcolor: formData.color, width: 48, height: 48 }}>
                    {React.createElement(getIconComponent(formData.icon), { sx: { fontSize: 24 } })}
                  </Avatar>
                  <Box>
                    <Typography variant="h6">{formData.name || 'Badge Name'}</Typography>
                    <Typography variant="body2" color="text.secondary">
                      {formData.description || 'Badge description will appear here'}
                    </Typography>
                    <Box display="flex" gap={1} mt={1}>
                      <Chip label={formData.type} size="small" variant="outlined" />
                      {formData.autoAssign && (
                        <Chip 
                          label={`Auto: ${BADGE_CONDITION_TYPES.find(t => t.value === formData.conditionType)?.label || formData.conditionType}`} 
                          size="small" 
                          color="primary" 
                          variant="outlined" 
                        />
                      )}
                      <Chip 
                        label={formData.isActive ? 'Active' : 'Inactive'} 
                        size="small" 
                        color={formData.isActive ? 'success' : 'default'} 
                      />
                    </Box>
                  </Box>
                </Box>
              </Card>
            </Grid>
            
            <Grid item xs={12}>
              <Box display="flex" flexDirection="column" gap={1}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={formData.isActive}
                      onChange={(e) => setFormData(prev => ({ ...prev, isActive: e.target.checked }))}
                    />
                  }
                  label="Active"
                />
                <FormControlLabel
                  control={
                    <Switch
                      checked={formData.autoAssign}
                      onChange={(e) => setFormData(prev => ({ ...prev, autoAssign: e.target.checked }))}
                    />
                  }
                  label="Auto Assign"
                />
              </Box>
            </Grid>
            
            {formData.autoAssign && (
              <>
                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <InputLabel>Condition Type</InputLabel>
                    <Select
                      value={formData.conditionType}
                      onChange={(e) => setFormData(prev => ({ ...prev, conditionType: e.target.value }))}
                    >
                      {BADGE_CONDITION_TYPES.map(type => (
                        <MenuItem key={type.value} value={type.value}>
                          {type.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Threshold"
                    type="number"
                    value={formData.threshold}
                    onChange={(e) => setFormData(prev => ({ ...prev, threshold: parseInt(e.target.value) }))}
                  />
                </Grid>
                
                {formData.conditionType === 'SPECIFIC_MOVIE_WATCHED' && (
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Movie IDs"
                      placeholder="movie-id-1,movie-id-2"
                      value={formData.movieIds}
                      onChange={(e) => setFormData(prev => ({ ...prev, movieIds: e.target.value }))}
                      helperText="Comma-separated movie IDs"
                    />
                  </Grid>
                )}
                
                {formData.conditionType === 'GENRE_WATCHED_COUNT' && (
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Genre"
                      value={formData.genre}
                      onChange={(e) => setFormData(prev => ({ ...prev, genre: e.target.value }))}
                    />
                  </Grid>
                )}
                
                {formData.conditionType === 'SEASONAL_ACTIVITY' && (
                  <>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Genre"
                        value={formData.genre}
                        onChange={(e) => setFormData(prev => ({ ...prev, genre: e.target.value }))}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth>
                        <InputLabel>Month</InputLabel>
                        <Select
                          value={formData.month}
                          onChange={(e) => setFormData(prev => ({ ...prev, month: e.target.value }))}
                        >
                          {Array.from({ length: 12 }, (_, i) => (
                            <MenuItem key={i + 1} value={i + 1}>
                              {new Date(0, i).toLocaleString('default', { month: 'long' })}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  </>
                )}
              </>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} startIcon={<Cancel />}>
            Cancel
          </Button>
          <Button onClick={handleSave} variant="contained" startIcon={<Save />}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default EnhancedBadgeManager;